import { render, staticRenderFns } from "./ItemDestaque.vue?vue&type=template&id=6515ac85&class=itemdestaque&"
import script from "./ItemDestaque.vue?vue&type=script&lang=js&"
export * from "./ItemDestaque.vue?vue&type=script&lang=js&"
import style0 from "./ItemDestaque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports